/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Protestant_Religion26Inputs */

const en__field__enum_teachingsubjects_subject_protestant_religion26 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Protestant_Religion26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protestant Religion`)
};

const de__field__enum_teachingsubjects_subject_protestant_religion26 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Protestant_Religion26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evangelische Religion`)
};

/**
* | output |
* | --- |
* | "Protestant Religion" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Protestant_Religion26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_protestant_religion26 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Protestant_Religion26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Protestant_Religion26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_protestant_religion26(inputs)
	return de__field__enum_teachingsubjects_subject_protestant_religion26(inputs)
});
export { _field__enum_teachingsubjects_subject_protestant_religion26 as "_field__enum_teachingSubjects_SUBJECT_PROTESTANT_RELIGION" }